module.exports = __webpack_public_path__ + "img/Paso 1.585fb924.png";